// extracted by mini-css-extract-plugin
export default {"group":"CheckboxGroup_group__Z-D+8","option-container":"CheckboxGroup_option-container__7JI3v"};